import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

export const hasDiscountMortgageDefinition = definitionFactory({
  key: 'is_discount_mortgage',
  mapper: jsonQueryValue => {
    return [
      {
        label: 'Льготная ипотека',
        value: jsonQueryValue,
      },
    ];
  },
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'is_discount_mortgage', options);
  },
});
